import { NgModule } from '@angular/core';
import { ApprovalPopupComponent } from './components/approval-popup/approval-popup.component';
import { InfoPopupComponent } from './components/info-popup/info-popup.component';
import { PopupComponent } from './components/popup/popup.component';
import { RadioButtonsPopupComponent } from './components/radio-buttons-popup/radio-buttons-popup.component';
import { SharedModule } from '../shared/shared.module';
import { CommonModule } from '@angular/common';
import { DetailsConfirmPopupComponent } from './components/details-confirm-popup/details-confirm-popup.component';
import { CountryListPopupComponent } from './components/country-list-popup/country-list-popup.component';
import { AddressBookPopupComponent } from './components/address-book-popup/address-book-popup.component';
import { DefaultPortfolioSelectorComponent } from './components/default-portfolio-selector/default-portfolio-selector.component';
import { PersonalArchiveMessageComponent } from './components/personal-archive-message/personal-archive-message.component';
import { UploadDocumentComponent } from './components/upload-document/upload-document.component';
import { ErrorHandlingPopupComponent } from './components/error-handling-popup/error-handling-popup.component';
import { VirtualScrollerModule } from '@iharbeck/ngx-virtual-scroller';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';
import { SentooPaymentPopupComponent } from './components/sentoo-payment/sentoo-payment-popup.component';

const DialogsComponents = [
  { name: 'Popup', type: PopupComponent },
  { name: 'MessagesDetailsPopup', type: PopupComponent },
  { name: 'MessagesDeletePopup', type: PopupComponent },
  { name: 'DefaultPortfolioSelector', type: DefaultPortfolioSelectorComponent },
  { name: 'ErrorHandlingPopup', type: PopupComponent },
];

@NgModule({
  declarations: [
    ApprovalPopupComponent,
    SentooPaymentPopupComponent,
    InfoPopupComponent,
    PopupComponent,
    RadioButtonsPopupComponent,
    DetailsConfirmPopupComponent,
    CountryListPopupComponent,
    AddressBookPopupComponent,
    DefaultPortfolioSelectorComponent,
    PersonalArchiveMessageComponent,
    UploadDocumentComponent,
    ErrorHandlingPopupComponent
  ],
  imports: [CommonModule, JssModule, SharedModule, VirtualScrollerModule],
  entryComponents: [
    InfoPopupComponent,
    ApprovalPopupComponent,
    SentooPaymentPopupComponent,
    RadioButtonsPopupComponent,
    DetailsConfirmPopupComponent,
    CountryListPopupComponent,
    AddressBookPopupComponent,
    PersonalArchiveMessageComponent,
    UploadDocumentComponent,
    ErrorHandlingPopupComponent
  ]
})
export class DialogsModule {}

export { DialogsComponents };
